import { cn } from '@/lib/utils';
import type { EstadoOt } from '@sime/shared';
import { STATE_COLORS, STATE_LABELS } from '@sime/shared';

interface NeuBadgeProps {
  estado: EstadoOt;
  size?: 'sm' | 'md';
  className?: string;
}

export function NeuBadge({ estado, size = 'md', className }: NeuBadgeProps) {
  const colors = STATE_COLORS[estado];

  // Title attribute carries full label so truncated `sm` badges remain
  // disambiguated (hover + screen reader). sm size also drops `truncate` —
  // STATE_LABELS values are all ≤ 12 chars (invariant pinned by ui.test.tsx).
  const label = STATE_LABELS[estado];
  return (
    <span
      role="status"
      title={label}
      style={{ backgroundColor: colors.bg, color: colors.text }}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-medium whitespace-nowrap max-w-full',
        size === 'md' && 'truncate',
        'shadow-soft-inset-badge',
        size === 'sm' && 'px-2 py-0.5 text-xs',
        size === 'md' && 'px-3 py-1 text-sm',
        className,
      )}
    >
      <span
        className="badge-dot"
        style={{ backgroundColor: colors.text, boxShadow: `0 0 6px ${colors.bg}` }}
      />
      {label}
    </span>
  );
}
